
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Arches Icons","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M500 1000C224.3 1000 0 775.7 0 500S224.3 0 500 0s500 224.3 500 500-224.3 500-500 500zm0-902.36C278.14 97.64 97.64 278.14 97.64 500S278.14 902.36 500 902.36 902.36 721.86 902.36 500 721.86 97.64 500 97.64zm0 95.63c-124 0-224.61 100.56-224.61 224.61 0 133.47 146 321.24 202.59 389a28.68 28.68 0 0044 0c56.57-67.75 202.58-255.52 202.58-389 .05-124.05-100.51-224.61-224.56-224.61zM500 500a82.12 82.12 0 1182.12-82.12A82.12 82.12 0 01500 500z","fill":"#e0dbc8"}})])
          )
        }
      }
    